import {
  Column,
  Flex,
  Heading,
  Row,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { CreditTypeSegmentedControl } from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/CreditTypeSegmentedControl';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { FrequencyFields } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/CreditFrequencyLayout/FrequencyFields/FrequencyFields';
import { StartDateInputWrapper } from './StartDateInputWrapper';
import { DeactivationFields } from './DeactivationFields';

export function CreditFrequencyLayout(): JSX.Element {
  const {
    isEditing,
    formValues: { isRepeating },
  } = useMealCreditFormData();
  return (
    <Square inset="md" bg="stencilHighlight">
      <Stack y="sm">
        <Heading variant="h6">How often does the credit refresh?</Heading>
      </Stack>
      <Stack y="x-sm">
        <Row gutter={12}>
          <Column phone={3} gutter={12}>
            <CreditTypeSegmentedControl
              id="frequency"
              name="frequency"
              disabled={isEditing}
            />
          </Column>
          <Column phone={9} gutter={12}>
            <FrequencyFields />
          </Column>
        </Row>
      </Stack>
      <Stack y={isRepeating ? 'sm' : 'none'}>
        <Row>
          <Column phone={2}>
            <Flex flexDirection="column">
              <StartDateInputWrapper />
            </Flex>
          </Column>
        </Row>
      </Stack>

      {isRepeating && <DeactivationFields />}
    </Square>
  );
}
